var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDilLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.8 18",
    fill: "#fbfbfb",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4166_00000016786647986205267310000006360696714458565544_",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4165_00000000935273776925360550000005003482894531434426_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7411_00000052097550595528871170000001066866502481234860_",
    d: "M5,5h6c0.6,0,1-0.4,1-1l0,0 c0-0.6-0.4-1-1-1H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h6c0.6,0,1-0.4,1-1l0,0c0-0.6-0.4-1-1-1H5V5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7412_00000127017924034809551100000006747330487866600615_",
    d: "M20.6,11.6l-2.8-2.8 c-0.2-0.2-0.5-0.2-0.7,0C17.1,8.9,17,9.1,17,9.2V11h-7c-0.6,0-1,0.4-1,1l0,0c0,0.6,0.4,1,1,1h7v1.8c0,0.3,0.2,0.5,0.5,0.5 c0.1,0,0.3-0.1,0.3-0.1l2.8-2.8C20.8,12.2,20.8,11.9,20.6,11.6C20.7,11.7,20.7,11.7,20.6,11.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDilLogout);
export default __webpack_public_path__ + "static/media/icon_dil_logout.1c64b09c872d09404de48aef4dba2fa2.svg";
export { ForwardRef as ReactComponent };